import React from 'react';
import { BlockedSwitchingButtons, DefaultButtons } from './modal-buttons/modal-buttons';

interface Props {
	translations: Translations;
	img?: React.ReactNode;
	onConfirm: () => void;
	onCancel: () => void;
	blockedSwitching?: boolean;
}

export interface Translations {
	title: string;
	description: string;
	settingsText: string;
	cancel: string;
	apply: string;
	ok: string;
}

const SoftRolloutModal: React.FC<Props> = ({ translations, img, onConfirm, onCancel, blockedSwitching }) => {
	return (
		<div className="soft-rollout-modal-content">
			<div className="img-area">{img || 'image here'}</div>
			<div className="content-area">
				<div className="title">{translations.title}</div>
				<div className="text-area">
					<div className="description">{translations.description}</div>
					{!blockedSwitching && <div className="settings-text">{translations.settingsText}</div>}
				</div>
			</div>
			<div className="buttons-area">
				{blockedSwitching ? (
					<BlockedSwitchingButtons onClick={onConfirm} translations={translations} />
				) : (
					<DefaultButtons onConfirm={onConfirm} onCancel={onCancel} translations={translations} />
				)}
			</div>
		</div>
	);
};

export default SoftRolloutModal;
